import { apiClient } from "./apiClient";

// Edge listesini getir (role'e göre filtrelenmiş)
export async function getEdges(accessToken, tenantId = null) {
  const params = tenantId ? { tenant_id: tenantId } : {};
  const res = await apiClient.get("/edges/list", {
    headers: { Authorization: `Bearer ${accessToken}` },
    params,
  });
  const data = res.data;
  return data.items || data;
}

// Tek bir edge getir (DB id ile)
export async function getEdgeById(accessToken, edgeDbId) {
  const res = await apiClient.get(`/edges/${edgeDbId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Edge getir (edgeId ile - örn: EDGE-TR-001)
export async function getEdgeByEdgeId(accessToken, edgeId) {
  const res = await apiClient.get(`/edges/by-edgeid/${edgeId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Yeni edge kaydet
export async function registerEdge(accessToken, tenantId, edgeData) {
  const res = await apiClient.post(`/edges/register/${tenantId}`, edgeData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Edge güncelle
export async function updateEdge(accessToken, edgeDbId, edgeData) {
  const res = await apiClient.put(`/edges/${edgeDbId}`, edgeData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Edge sil
export async function deleteEdge(accessToken, edgeDbId) {
  const res = await apiClient.delete(`/edges/${edgeDbId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}
